import React from "react";
import { LOGO_WIDE } from "./Logo";

/** Presidential-Blue footer band with larger Sentry logo + tagline. */
export default function BrandFooter() {
  return (
    <footer className="mt-16" style={{ background: "#0F1644" }} data-testid="brand-footer">
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-5">
          <img src={LOGO_WIDE} alt="Sentry Cloud IT" style={{ height: 64, width: "auto" }}/>
          <div className="hidden md:block text-white/70 text-sm">
            <div className="font-semibold text-white">Sentry Cloud IT</div>
            <div className="text-xs uppercase tracking-[0.2em]" style={{ color: "#00C7FF" }}>Speed · Strength · Security</div>
          </div>
        </div>
        <div className="text-sm text-white/70 text-center md:text-right">
          <div>© {new Date().getFullYear()} Sentry Cloud IT. All rights reserved.</div>
          <a href="https://sentrycloudit.com" target="_blank" rel="noreferrer" className="text-xs hover:underline" style={{ color: "#00C7FF" }}>sentrycloudit.com</a>
        </div>
      </div>
    </footer>
  );
}
